import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.scss']
})
export class FacilitiesComponent implements OnInit {

  facilities = [
    { name: 'Hostel', icon: 'fas fa-chart-simple', color: '#3ecd5e' },
    { name: 'Canteen', icon: 'fas fa-mug-hot', color: '#e44002' },
    { name: 'Medical Room', icon: 'fas fa-truck-medical', color: '#0d6efd' },
    { name: 'Library', icon: 'fas fa-book-open', color: '#e44002' },
    { name: 'Computer Lab', icon: 'fas fa-desktop', color: '#0ea5e9' },
    { name: 'Chemistry Lab', icon: 'fas fa-flask', color: '#3ecd5e' }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
